import {
  AnchorButtonProps,
  Callout,
  Intent,
  Position,
} from '@blueprintjs/core';
import { IconNames } from '@blueprintjs/icons';
import * as React from 'react';

import { useMessageLineInfo } from 'src/containers/Voicebox/Message/hooks/useMessageLineInfo';
import { MessageButton } from 'src/containers/Voicebox/Message/MessageButton';
import { voiceboxConversationIdSelector } from 'src/selectors/voicebox';
import { askVoicebox } from 'src/store/voicebox/voicebox.slice';
import { useReduxDispatch } from 'src/utils/hooks/useReduxDispatch';
import { useReduxSelector } from 'src/utils/hooks/useReduxSelector';

// TODO long lines without spaces go off the container
export const UserMessage: React.VFC<{
  buttonProps?: AnchorButtonProps;
  buttonTooltip?: string;
  errored?: boolean;
  disabled?: boolean;
  pending?: boolean;
  userPrompt: string;
}> = ({
  buttonProps,
  buttonTooltip,
  errored,
  disabled,
  pending,
  userPrompt,
}) => (
  <div className="sd-voicebox__message__user">
    <div className="sd-voicebox__message__user__left-elements">
      <MessageButton
        buttonProps={buttonProps}
        buttonTooltip={buttonTooltip}
        disabled={disabled}
        pending={pending}
        tooltipPosition={Position.LEFT}
      />
    </div>
    <Callout
      className="sd-voicebox__message__user__callout"
      icon={null}
      intent={errored ? Intent.DANGER : Intent.PRIMARY}
    >
      {userPrompt}
    </Callout>
  </div>
);

export const UserMessageWithError: React.VFC<{
  pending: boolean;
  userPrompt: string;
}> = ({ pending, userPrompt }) => {
  const dispatch = useReduxDispatch();
  const conversationId = useReduxSelector(voiceboxConversationIdSelector);

  const { disabled, disabledReason } = useMessageLineInfo();

  const buttonProps = {
    icon: IconNames.RESET,
    onClick: async () => {
      // TODO reuse and replace current messages?
      await dispatch(
        askVoicebox({ query: userPrompt, conversationId, describe: true })
      );
    },
  };

  return (
    <UserMessage
      buttonProps={buttonProps}
      buttonTooltip={disabledReason}
      disabled={disabled}
      errored
      pending={pending}
      userPrompt={userPrompt}
    />
  );
};
